/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserCouponPayAvailableRespVo
 */
export interface GetUserCouponPayAvailableRespVo {
    /**
     * 用户优惠券ID（使用时提交）
     * @type {number}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    id?: number;
    /**
     * 优惠券名称（中文）
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    name?: string;
    /**
     * 优惠券名称（韩文）
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    nameKr?: string;
    /**
     * 优惠券名称（按当前语言）
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    displayName?: string;
    /**
     * 发行类型：1-管理员发放，2-活动发放
     * @type {number}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    grantType?: number;
    /**
     * 发行类型说明（按当前语言）
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    grantTypeDisplayName?: string;
    /**
     * 优惠券金额
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    amount?: string;
    /**
     * 货币代码
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    currencyCode?: string;
    /**
     * 是否长期有效：0-否，1-是；为1时前端显示“长期有效”
     * @type {number}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    longTerm?: 0 | 1 | null;
    /**
     * 有效期开始时间
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    beginTime?: string;
    /**
     * 有效期结束时间
     * @type {string}
     * @memberof GetUserCouponPayAvailableRespVo
     */
    endTime?: string;
}

/**
 * Check if a given object implements the GetUserCouponPayAvailableRespVo interface.
 */
export function instanceOfGetUserCouponPayAvailableRespVo(value: object): value is GetUserCouponPayAvailableRespVo {
    return true;
}

export function GetUserCouponPayAvailableRespVoFromJSON(json: any): GetUserCouponPayAvailableRespVo {
    return GetUserCouponPayAvailableRespVoFromJSONTyped(json, false);
}

export function GetUserCouponPayAvailableRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserCouponPayAvailableRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'grantType': json['grantType'] == null ? undefined : json['grantType'],
        'grantTypeDisplayName': json['grantTypeDisplayName'] == null ? undefined : json['grantTypeDisplayName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'longTerm': json['longTerm'] == null ? undefined : json['longTerm'],
        'beginTime': json['beginTime'] == null ? undefined : json['beginTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
    };
}

export function GetUserCouponPayAvailableRespVoToJSON(json: any): GetUserCouponPayAvailableRespVo {
    return GetUserCouponPayAvailableRespVoToJSONTyped(json, false);
}

export function GetUserCouponPayAvailableRespVoToJSONTyped(value?: GetUserCouponPayAvailableRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'nameKr': value['nameKr'],
        'displayName': value['displayName'],
        'grantType': value['grantType'],
        'grantTypeDisplayName': value['grantTypeDisplayName'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
        'longTerm': value['longTerm'],
        'beginTime': value['beginTime'],
        'endTime': value['endTime'],
    };
}

